import { render, staticRenderFns } from "./FiltroLocal.vue?vue&type=template&id=6bd68e2d"
import script from "./FiltroLocal.vue?vue&type=script&lang=js"
export * from "./FiltroLocal.vue?vue&type=script&lang=js"
import style0 from "./FiltroLocal.vue?vue&type=style&index=0&id=6bd68e2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports